import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_PERIOD_TYPE } from "src/api-setup/api-endpoints";

/*
 * Period types the tenant defines (Month / Quarter / Year, ...). Drives the
 * granularity strip on the Earnings Overview card.
 *
 * Ported from useSelectPeriod in the mobile app; the filter and sort are the
 * same so both platforms list the periods in the same order.
 */
export const getPeriodTypes = async (cookiesData, dispatch) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();
    const requestBody = {
      in_filter: "AND a.period_type_hierarchy_level IS NOT NULL",
      in_sort_number: 3,
      in_sort_order: "DESC",
    };

    const response = await POSTAPI(false, GET_PERIOD_TYPE, null, apiHeaders, requestBody, dispatch);
    const rowResult = response?.data?.row_result;

    return Array.isArray(rowResult) ? rowResult : [];
  } catch (error) {
    console.error("Error fetching period types:", error);
    return [];
  }
};
